import { i18n } from '../../lang'

export const columnList = [
  { type: 'id', custom: { width: 60 } },
  { type: 'country_code', custom: { width: 60 } },
  { type: 'store_name', custom: { minWidth: 160 } },
  { type: 'plan_name', custom: { minWidth: 100 } },
  { type: 'billing_interval', custom: { minWidth: 60 } },
  { type: 'start_date', custom: { minWidth: 150 } },
  { type: 'terminated_date', custom: { minWidth: 150 } },
  { type: 'price', custom: { minWidth: 60 } },
]
